import React from "react";

import { AlertTriangle, CheckCircle2 } from "lucide-react";

import { useSalesConditions } from "~/hooks/useSalesConditions";
import { Client } from "~/types/client";

interface ClientFinancialInfoProps {
  client: Client;
}

const ClientFinancialInfo: React.FC<ClientFinancialInfoProps> = ({
  client,
}) => {
  const { getConditionById } = useSalesConditions();
  const salesCondition = client.salesConditionId
    ? getConditionById(client.salesConditionId)
    : null;

  return (
    <div className="mb-6 rounded-lg border bg-slate-50 p-4">
      <h3 className="mb-3 text-lg font-medium">Condición de Venta</h3>

      {salesCondition ? (
        <div className="flex items-start gap-2">
          <CheckCircle2 className="mt-0.5 h-5 w-5 text-green-500" />
          <div>
            <p className="font-medium">{salesCondition.name}</p>
            <p className="text-sm text-gray-600">
              {salesCondition.type === "prepaid" && "Pago anticipado"}
              {salesCondition.type === "credit_line" &&
                `Crédito - ${salesCondition.maximumDays || 0} días`}
              {salesCondition.type === "external_platform" &&
                `${salesCondition.externalPlatformName || "Plataforma externa"} - ${salesCondition.maximumDays || 0} días`}
            </p>
            {salesCondition.requiresPrepayment && (
              <p className="mt-1 text-sm text-amber-600">
                <span className="font-medium">Nota:</span> Esta condición
                requiere pago anticipado antes del despacho
              </p>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-start gap-2">
          <AlertTriangle className="mt-0.5 h-5 w-5 text-amber-500" />
          <div>
            <p className="font-medium text-amber-800">
              Pendiente de aprobación
            </p>
            <p className="text-sm text-gray-600">
              Este cliente no tiene una condición de venta asignada. Contacte a
              un administrador para configurar las condiciones de pago.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientFinancialInfo;
